import { Box, Chip, Stack } from '@mui/material'
import { type FC } from 'react'
import { type CandidateFilterState } from 'shared/hooks/candidateSearchUrlState'
import {
    StarRatingFilter,
    ScreeningTypeFilter,
} from './CandidateMinimalFilters'
import { FilterWrapper } from './FilterPrimitives'
import { toggleChipSx } from './minimalFilterStyles'

const REMEET_OPTIONS = ['only', 'exclude'] as const
const REMEET_LABELS: Record<string, string> = {
    only: 'Only Remeet',
    exclude: 'Exclude Remeet',
}

interface CandidateRatingFilterSectionProps {
    filters: CandidateFilterState
    updateFilters: (patch: Partial<CandidateFilterState>) => void
}

export const CandidateRatingFilterSection: FC<
    CandidateRatingFilterSectionProps
> = ({ filters, updateFilters }) => {
    return (
        <Stack gap={2.5} sx={{ p: 2 }}>
            <StarRatingFilter
                value={{
                    min: filters.starRatingMin,
                    max: filters.starRatingMax,
                }}
                onChange={(min, max) =>
                    updateFilters({
                        starRatingMin: min,
                        starRatingMax: max,
                    })
                }
            />
            <ScreeningTypeFilter
                templateIds={filters.screeningNoteTemplateIds}
                starMin={filters.screeningNoteStarRatingMin}
                starMax={filters.screeningNoteStarRatingMax}
                onChange={(
                    screeningNoteTemplateIds,
                    screeningNoteStarRatingMin,
                    screeningNoteStarRatingMax
                ) =>
                    updateFilters({
                        screeningNoteTemplateIds,
                        screeningNoteStarRatingMin,
                        screeningNoteStarRatingMax,
                    })
                }
            />
            <FilterWrapper label="Remeet">
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {REMEET_OPTIONS.map((opt) => (
                        <Chip
                            key={opt}
                            label={REMEET_LABELS[opt]}
                            size="small"
                            onClick={() =>
                                updateFilters({
                                    remeetFilter:
                                        filters.remeetFilter === opt
                                            ? undefined
                                            : opt,
                                })
                            }
                            sx={toggleChipSx(filters.remeetFilter === opt)}
                        />
                    ))}
                </Box>
            </FilterWrapper>
        </Stack>
    )
}
